export const SERVICE_CATEGORIES = ["Auditing", "Consulting", "Advisory", "Tax", "Law", "Other"];
export const CORE_CATEGORIES = ["Auditing", "Consulting", "Advisory", "Tax", "Law"];

export const INDUSTRIES = [
  "Financial services", "Banking", "Insurance", "Technology", "Telecommunications", "Healthcare and life sciences",
  "Energy and utilities", "Manufacturing and industrials", "Consumer and retail", "Real estate and construction",
  "Transport and logistics", "Public sector", "Professional services", "Media and entertainment", "Other",
];

export const DURATIONS = ["Not yet known", "Less than 1 month", "1–3 months", "3–6 months", "6–12 months", "More than 12 months"];

export const BUDGETS = ["Prefer not to say", "Under USD 10,000", "USD 10,000–50,000", "USD 50,000–150,000", "USD 150,000–500,000", "Above USD 500,000"];

export const CONTACT_METHODS = ["Email", "Phone", "Video call"];

export const AVAILABILITY = ["Full-time", "Part-time", "Project-based", "Ad hoc / advisory"];

export const ENGAGEMENT_TYPES = [
  "Short-term projects", "Long-term engagements", "Interim roles", "Advisory retainers", "Co-sourced team support", "Expert review / second opinion",
];

export const CONTACT_TOPICS = ["General enquiry", "Partnerships", "Media", "Expert network", "Privacy request", "Other"];

export const ENQUIRY_STATUSES = ["New", "Reviewing", "Clarification Required", "Matching in Progress", "Shortlist Prepared", "Introduction in Progress", "Closed"];
export const APPLICATION_STATUSES = ["Received", "Under Review", "Information Required", "Approved", "Declined"];
export const MESSAGE_STATUSES = ["New", "In Progress", "Responded", "Closed"];
